<template>
  <DxPopup
    ref="popup"
    title-template="popup-header"
    content-template="popup-content"
    class="popup-container"
    :class="customClass"
    :shading="shading"
    :shading-color="shadingColor"
    :visible="visible"
    :drag-enabled="dragEnabled"
    :show-title="showTitle"
    :width="width"
    :height="height"
    :position="position"
    :close-on-outside-click="closeOnOutsideClick"
    :full-screen="fullScreen"
    :resize-enabled="resizeEnabled"
    :title="title"
    :on-initialized="onInit"
    :container="container"
    :max-height="maxHeight"
    :max-width="maxWidth"
    :min-height="minHeight"
    :min-width="minWidth"
    :rtl-enabled="rtlEnabled"
    @keydown="handleKeyDown"
    @hidden="close"
  >
    <template #popup-header>
      <div class="popup-header">
        <div class="flex item-center justify-between">
          <div class="popup-header-title">
            <slot name="title">
              {{ title }}
            </slot>
          </div>
          <div class="popup-header-icon flex item-center">
            <ms-icon
              v-if="isShowFullscreen"
              class="m-r-8"
              :icon="!fullScreen ? 'mi-expand' : 'mi-collapse'"
              :tooltip-content="
                !fullScreen
                  ? $t('i18nCommon.Expand')
                  : $t('i18nCommon.Collapse')
              "
              @click="changeFullScreen()"
            />
            <ms-icon
              v-if="isShowIconClose"
              class="popup-icon-close"
              :icon="iconClose"
              :tooltip-content="$t('i18nCommon.Close')"
              @click="close"
            />
          </div>
        </div>
        <div class="popup-header-subtitle">
          {{ subTitle }}
        </div>

        <!-- tool header -->
        <div
          v-if="isShowTool"
          class="w-full"
        >
          <slot name="popup-tool" />
        </div>
      </div>
    </template>
    <template #popup-content>
      <div
        class="w-full h-full flex-col"
        @keydown="handleKeyDown"
      >
        <DxScrollView
          :direction="direction"
          :class="{ 'popup-content': isShowFooter, 'h-100': !isShowFooter }"
        >
          <div class="h-full">
            <slot name="content" />
          </div>
        </DxScrollView>
        <div
          v-if="isShowFooter"
          :class="['p-y-12 p-x-24 popup-footer',{'sticky-footer-bottom' : isStickyFooterBottom}]"
        >
          <slot name="footer" />
        </div>
      </div>
    </template>
  </DxPopup>
</template>
<script>
import { DxPopup } from "devextreme-vue/popup";
import { DxScrollView } from "devextreme-vue/scroll-view";
export default {
  name: "MsPopup",
  components: {
    DxPopup,
    DxScrollView,
  },
  props: {
    visible: {
      type: [Boolean, String],
      default: false,
    },
    // chiều rộng của popup
    width: {
      type: [String, Number],
      default: 500,
    },
    // chiều cao của popup
    height: {
      type: [String, Number],
      default: "auto",
    },
    // chiều cao max của popup
    maxHeight: {
      type: String,
      default: null,
    },
    // chiều rộng max của popup
    maxWidth: {
      type: String,
      default: null,
    },
    // chiều cao min của popup
    minHeight: {
      type: String,
      default: "200",
    },
    // chiều rộng min của popup
    minWidth: {
      type: String,
      default: "200",
    },
    // vị trí khi mở popup lên
    position: {
      type: String,
      default: "center",
    },
    // click ra ngoài popup thì tắt popup
    closeOnOutsideClick: {
      type: [Boolean, String],
      default: false,
    },
    // di chuyển vị trí của popup
    dragEnabled: {
      type: [Boolean, String],
      default: false,
    },
    // có cho chỉnh kích thước popup không
    resizeEnabled: {
      type: [Boolean, String],
      default: true,
    },
    // có hiển thị header popup không
    showTitle: {
      type: [Boolean, String],
      default: true,
    },
    // title của popup
    title: {
      type: String,
      default: "Title-Popup",
    },
    // icon đóng popup
    iconClose: {
      type: String,
      default: "mi-close-2",
    },
    // có hiển thị icon phóng to thu nhỏ không
    isShowFullscreen: {
      type: [Boolean, String],
      default: false,
    },
    // text dưới title popup
    subTitle: {
      type: String,
      default: "",
    },
    // phạm vi hiện popup(class hoặc id)
    container: {
      type: String,
      default: "",
    },
    // hiển thị icon xóa không
    isShowIconClose: {
      type: [Boolean, String],
      default: true,
    },
    // có cho custom nền ngoài popup không
    shading: {
      type: [Boolean, String],
      default: true,
    },
    // màu background ngoài popup khi shading=true
    shadingColor: {
      type: String,
      default: "rgba(0, 0, 0, 0.3)",
    },
    // có đảo vị trị trái phải với nhau không
    rtlEnabled: {
      type: [Boolean, String],
      default: false,
    },
    customClass: {
      type: String,
      default: "",
    },
    isShowFooter: {
      type: Boolean,
      default: true,
    },
    isShowTool: {
      type: Boolean,
      default: false,
    },
    direction: {
      type: String,
      default: "vertical",
    },

    // có sticky footer ở bottom của popup không
    isStickyFooterBottom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fullScreen: false,
    };
  },
  methods: {
    /**
     * Hàm xử lý ghi đè khi nhấn key esc để đóng popup
     * created by nhson 5-7-2021
     */
    onInit(e) {
      e.component.registerKeyHandler("escape", () => {
        this.$emit("keyEscape");
      });
      e.component.registerKeyHandler("enter", () => {
        this.$emit("keyEnter");
      });
    },
    /**
     * Hàm xử lý đóng popup
     * created by nhson 5-7-2021
     */
    close() {
      this.$emit("onClose");
    },
    /**
     * Hàm xử lý full screen
     * created by nhson 5-7-2021
     */
    changeFullScreen() {
      this.fullScreen = !this.fullScreen;
      this.$emit("changeFullScreen");
    },
    /**
     * Hàm xử lý keybroad
     * created by nhson 5-7-2021
     */
    handleKeyDown(e) {
      if (e.key === "Escape") {
        this.$emit("keyEscape");
      } else if (e.key === "Enter") {
        this.$emit("keyEnter");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.popup-container {
  .popup-header {
    padding: 24px 24px;
    .popup-header-title {
      letter-spacing: 0.576px;
      font-size: 20px;
      font-weight: bold;
      color: #1E1F1F;
    }
    .popup-header-subtitle {
      color: #666;
      letter-spacing: 0.196px;
      font-size: 14px;
    }
  }
  .popup-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    background: #f2f2f2;
  }
  .sticky-footer-bottom{
    position: absolute;
    bottom: 0;
    width: 100%;
    left:0;
  }
}
</style>
<style lang="scss" scoped>
.popup-container.dx-popup-wrapper:not(.center) {
  .dx-popup-normal {
    display: flex;
    flex-direction: column;
  }
}
.center {
  .dx-overlay-content {
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    position: fixed;
  }
}

.popup-icon-close {
  margin-right: 2px;
}
.popup-container {
  .dx-overlay-content.dx-popup-fullscreen {
    border-radius: 8px !important;
    top: 24px !important;
    left: 24px !important;
    width: calc(100% - 48px) !important;
    height: calc(100vh - 48px) !important;
  }
  .dx-closebutton.dx-button.dx-button-normal.dx-button-mode-contained.dx-widget.dx-button-has-icon {
    border: none;
    outline: none;
    border-radius: 50% !important;
    &:hover {
      background-color: #eff1f6 !important;
    }
    &:active {
      background-color: #e8eaef !important;
    }
  }
  .dx-overlay-content.dx-resizable.dx-popup-normal.dx-popup-flex-height {
    box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 8px;
  }
  .dx-popup-title {
    border: none;
  }
  .dx-popup-content {
    padding: 0px !important;
  }
}
.dx-popup-content {
  padding: 0px !important;
}
</style>
